import React from "react";
import { Form } from "@ant-design/compatible";
import "@ant-design/compatible/assets/index.css";
import { Input, Modal, Select, InputNumber } from "antd";

const { Option } = Select;

class UpdateForm extends React.Component {
  compareToFirstPassword = (rule, value, callback) => {
    const { form } = this.props;

    if (value && value !== form.getFieldValue("password")) {
      callback("Two passwords that you enter is inconsistent!");
    } else {
      callback();
    }
  };

  validateToNextPassword = async (rule, value, callback) => {
    const { form } = this.props;

    if (value) {
      form.validateFields(["confirm"], { force: true });
    } else {
      callback();
    }
  };

  render() {
    const {
      visible,
      onCancel,
      onCreate,
      form,
      updateInitialValue,
      indexesGetData,
    } = this.props;
    const { getFieldDecorator } = form;

    return (
      <Modal
        visible={visible}
        title="Update a main role"
        okText="Update"
        onCancel={onCancel}
        onOk={onCreate}
      >
        <Form layout="vertical">
          <Form.Item label="Id" style={{ display: "none" }}>
            {getFieldDecorator("_id", {
              initialValue:
                updateInitialValue && updateInitialValue._id
                  ? updateInitialValue._id
                  : "",
              rules: [
                {
                  required: true,
                  message: "Please input the id!",
                },
              ],
            })(<Input />)}
          </Form.Item>

          <Form.Item label="Main Role Name">
            {getFieldDecorator("main_role_name", {
              initialValue:
                updateInitialValue && updateInitialValue.main_role_name
                  ? updateInitialValue.main_role_name
                  : "",
              rules: [
                {
                  required: true,
                  message: "Please input the main role name!",
                },
              ],
            })(<Input />)}
          </Form.Item>
        </Form>
      </Modal>
    );
  }
}

const UserManagerUpdateForm = Form.create({ name: "user_manager_update_form" });

export default UserManagerUpdateForm(UpdateForm);
